import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    Dialog,
    Divider,
    Grid,
    makeStyles,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core';
import axios from 'axios';
import './styles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    card: {
        textAlign: 'center',
        width: '100%',
    },
    bottomLine: {
        width: '100%',
        height: 0,
        // borderBottom: '1px solid #ccc !important',
        // '&:before': {
        //     borderBottom: '1px solid #ccc !important',
        // },
    },
}));
const OpenServicePopUp = (props) => {
    const { dataRow, openPopup, handlePopClose } = props;
    //console.log(dataRow, openPopup, handlePopClose, 'PROPS FROM Open service');
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    //     const [fullWidth, setFullWidth] = React.useState(true);
    //   const [maxWidth, setMaxWidth] = React.useState('sm');
    const classes = useStyles();

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={openPopup}
                onClose={handlePopClose}
                // disableBackdropClick
                aria-labelledby="responsive-open-service-dialog"
                className="open-service-dialog"
            >
                <Card className="open-service-popup">
                    <CardContent className={classes.card}>
                        {/* <Typography variant="h4"> G R Lavender Apartment</Typography> */}
                        <Typography variant="h4">Service ID</Typography>
                        <Typography className="pop-year">{dataRow.serviceId}</Typography>
                        {/* <Typography variant="h5">{dataRow['serviceYear']}</Typography> */}
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={1} className="main-grid-container">
                            <Grid item xs={12} sm={6}>
                                <div className="text-left">
                                    <Typography variant="subtitle1" className="open-title">
                                        {' '}
                                        Service Year
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.serviceYear}
                                    </Typography>
                                </div>
                                <div className="text-left">
                                    <Typography variant="subtitle1" className="open-title">
                                        Type of service{' '}
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.servicetypeId.servicetypeText}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="text-right">
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        Level 3 checklist & Draft Statements
                                    </Typography>
                                </div>
                            </Grid>
                            <div className="divider w100" />
                            <Grid item xs={12} sm={6}>
                                <div className="text-left">
                                    <Typography variant="subtitle1" className="open-title">
                                        Start Date
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.startDate}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="text-right">
                                    <Typography variant="subtitle1" className="open-title">
                                        Tentative close date
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.tentativeClosedate}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="text-left">
                                    <Typography variant="subtitle1" className="open-title">
                                        Client ID
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.clientId}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className="text-right">
                                    <Typography variant="subtitle1" className="open-title">
                                        Client Type
                                    </Typography>
                                    <Typography variant="subtitle2" className="open-title-sub">
                                        {dataRow.clientType}
                                    </Typography>
                                </div>
                            </Grid>
                            <div className="divider w100" />
                            <Grid item xs={12} sm={12}>
                                <div className="open-team-member">
                                    <Typography variant="subtitle1">Assigned Team Member</Typography>
                                    <Typography variant="subtitle2">Farhan</Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Button onClick={handlePopClose} type="button" className="txt-capitalize">
                                    Close
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Dialog>
        </div>
    );
};

export default OpenServicePopUp;
